/**
 * WebRTC ICE 配置管理模块。
 */

let iceServers: RTCIceServer[] = [
	{
		urls: ["stun:stun.devmate.displayten.com.cn:3478"],
	},
	{
		urls: ["turn:turn.devmate.displayten.com.cn:3478"],
		username: "admin",
		credential: "123456",
	},
];

// ICE 配置更新回调
let onIceConfigUpdate: ((servers: RTCIceServer[]) => void) | null = null;

/**
 * 设置 ICE 配置更新回调。
 * @param {(servers: RTCIceServer[]) => void} callback 配置更新时的回调函数
 */
export const setIceConfigUpdateCallback = (
	callback: ((servers: RTCIceServer[]) => void) | null,
) => {
	onIceConfigUpdate = callback;
};

/**
 * 更新 ICE 服务器配置。
 * @param {RTCIceServer[]} servers ICE 服务器配置数组
 */
export const updateIceServers = (servers: RTCIceServer[]) => {
	if (Array.isArray(servers) && servers.length > 0) {
		iceServers = servers;
		console.log("ICE servers updated:", iceServers);

		// 通知 WebRTC 连接配置已更新
		if (onIceConfigUpdate) {
			onIceConfigUpdate(iceServers);
		}
	}
};

/**
 * 获取完整的 WebRTC 配置。
 * @returns {{ iceServers: RTCIceServer[] }} WebRTC 配置对象
 */
export const getWebRTCConfig = () => {
	return {
		iceServers,
	};
};
